import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=40134c0a"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports